import { apiGet, apiPatch } from './client';
import type {
  DisclosureLevel2,
  DisclosureLevel2BatchRequest,
} from '../types/DisclosureLevel2';

export function getDisclosureLevel2(): Promise<DisclosureLevel2[]> {
  return apiGet<DisclosureLevel2[]>('/api/disclosure-level-2');
}

export function saveBatchDisclosureLevel2(
  added: DisclosureLevel2[],
  modified: DisclosureLevel2[],
  deletedIds: string[],
): Promise<DisclosureLevel2[]> {
  return apiPatch<DisclosureLevel2BatchRequest, DisclosureLevel2[]>(
    '/api/disclosure-level-2/batch',
    { added, modified, deleted: deletedIds },
  );
}
